import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" ZTY的电子书")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
}, "蜀ICP备2022002077号-1", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!

  return (_openBlock(), _createBlock(_component_a_layout_footer, { style: {"text-align":"center"} }, {
    default: _withCtx(() => [
      _hoisted_1,
      _withDirectives(_createElementVNode("span", null, " 欢迎:" + _toDisplayString(_ctx.user.name), 513), [
        [_vShow, _ctx.user.id]
      ]),
      _hoisted_2
    ]),
    _: 1
  }))
}